import {Action, action} from 'easy-peasy';
import i18n from 'i18n';

interface Task {
    id: string | number;
    [key: string]: any;
}

interface TaskStatusChoice {
    value: string;
    label: string;
}

interface TaskStore {
    items: Task[];
    loadTasks: Action<TaskStore, Task[]>;
    addOrEditTask: Action<TaskStore, Task>;
    deleteTask: Action<TaskStore, string | number>;
    selected: (string | number)[];
    loadSelected: Action<TaskStore, (string | number)[]>;
    select: Action<TaskStore, string | number>;
    deSelect: Action<TaskStore, string | number>;
    expanded: (string | number)[];
    expand: Action<TaskStore, string | number>;
    loadExpanded: Action<TaskStore, (string | number)[]>;
    taskStatusChoices: TaskStatusChoice[];
    loadTaskStatusChoices: Action<TaskStore, TaskStatusChoice[]>;
    filterAssigneeSelected: (string | number)[];
    selectFilterAssigneeSelected: Action<TaskStore, (string | number)[] | null>;
    filterTeamsSelected: (string | number)[];
    selectFilterTeamsSelected: Action<TaskStore, (string | number)[] | null>;
    taskStatusChoicesSelected: TaskStatusChoice[];
    selectTaskStatusChoicesSelected: Action<TaskStore, TaskStatusChoice[] | null>;
    searchPagesList: any[];
    setSearchPagesList: Action<TaskStore, any[]>;
    searchCurrentPage: number;
    setSearchCurrentPage: Action<TaskStore, number>;
    loading: boolean;
    setLoading: Action<TaskStore, boolean>;
}

const taskStore: TaskStore = {
    items: [],
    loadTasks: action((state, tasksList: Task[]) => {
        state.items = tasksList;
    }),
    addOrEditTask: action((state, task_: Task) => {
        const existingIndex = state.items.findIndex((t) => t.id === task_.id);

        if (existingIndex !== -1) {
            state.items.splice(existingIndex, 1);
        }

        state.items.unshift(task_);
    }),
    deleteTask: action((state, taskId: string | number) => {
        const index = state.items.findIndex((t) => t.id === taskId);

        state.items.splice(index, 1);
    }),
    selected: [],
    loadSelected: action((state, selectedList: (string | number)[]) => {
        state.selected = selectedList;
    }),
    select: action((state, selectedItemId: string | number) => {
        state.selected.push(selectedItemId);
    }),
    deSelect: action((state, selectedItemId: string | number) => {
        const selectedItemIndex = state.selected.findIndex((s) => s === selectedItemId);

        state.selected.splice(selectedItemIndex, 1);
    }),
    expanded: [],
    expand: action((state, expandedItemId: string | number) => {
        const expandedItemIndex = state.expanded.findIndex((ex) => ex === expandedItemId);

        if (expandedItemIndex > -1) {
            state.expanded.splice(expandedItemIndex, 1);
        } else {
            state.expanded.push(expandedItemId);
        }
    }),
    loadExpanded: action((state, expandedList: (string | number)[]) => {
        state.expanded = expandedList;
    }),
    taskStatusChoices: [],
    loadTaskStatusChoices: action((state, taskStatusChoicesList: TaskStatusChoice[]) => {
        state.taskStatusChoices = taskStatusChoicesList;
    }),
    filterAssigneeSelected: [],
    selectFilterAssigneeSelected: action((state, selectedAssignee: (string | number)[] | null) => {
        state.filterAssigneeSelected = (selectedAssignee || []);
    }),
    filterTeamsSelected: [],
    selectFilterTeamsSelected: action((state, selectedTeam: (string | number)[] | null) => {
        state.filterTeamsSelected = (selectedTeam || []);
    }),
    taskStatusChoicesSelected: [
        {
            value: 'pending',
            label: i18n.t('pending.text'),
        },
        {
            value: 'assigned',
            label: i18n.t('assigned.text'),
        },
        {
            value: 'in_progress',
            label: i18n.t('in_progress.text'),
        },
    ],
    selectTaskStatusChoicesSelected: action((state, selectedStatus: TaskStatusChoice[] | null) => {
        state.taskStatusChoicesSelected = (selectedStatus || []);
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList: any[]) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage: number) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading: boolean) => {
        state.loading = loading;
    }),
};

export default taskStore;
